const DISCARD_MESSAGE_FRAGMENTS = [
	'Warning',
	'Object Not Found Matching Id',
	'The user aborted a request',
];

const SEGMENT_LOAD_FAILED_MESSAGE =
	'Error sending segment performance metrics TypeError: Load failed';

const STACK_FRAME_URL = /(?:^|\n)\s*at [^\n]*https?:\/\//;

// Browsers replace a cross-origin exception with exactly this string, or Datadog wraps it as
// `Uncaught "Script error."`. Substring matching would drop real app errors that mention the same text.
const CROSS_ORIGIN_SCRIPT_ERROR = /^(?:Script error\.|Uncaught "Script error\.")$/;

/**
 * Cross-origin scripts are reported as a bare `Script error.` with the stack stripped by the
 * browser, so there is nothing to debug. The same message with a resolved stack is actionable.
 * Matched against the authoritative message only: a secondary field mentioning a script error is
 * not evidence, and a false positive here is permanent silent data loss.
 */
const isUnactionableScriptError = (message, stack) =>
	CROSS_ORIGIN_SCRIPT_ERROR.test(message) && !STACK_FRAME_URL.test(stack);

export const shouldDiscardRumEvent = (event) => {
	const haystack = [event?.message, event?.error?.message, event?.error?.type]
		.filter(Boolean)
		.join(' ');

	if (DISCARD_MESSAGE_FRAGMENTS.some((fragment) => haystack.includes(fragment))) {
		return true;
	}

	const errorMessage = event?.error?.message || event?.message || '';
	if (isUnactionableScriptError(errorMessage, event?.error?.stack || '')) {
		return true;
	}

	if (event?.error?.type === 'TypeError' && event?.error?.message === 'Load failed') {
		return true;
	}

	return (
		event?.message === SEGMENT_LOAD_FAILED_MESSAGE ||
		event?.error?.message === SEGMENT_LOAD_FAILED_MESSAGE
	);
};
